(() => {
  const popup = document.querySelector('[data-md-nl-popup]');
  if (!popup || popup.dataset.initialized === 'true') return;

  popup.dataset.initialized = 'true';

  const dialog = popup.querySelector('.md-nl-popup__dialog');
  const closeButtons = popup.querySelectorAll('[data-md-nl-close]');
  const success = popup.querySelector('[data-md-nl-success]');
  const preview = new URLSearchParams(window.location.search).get('md_nl_preview') === '1';
  const dismissedKey = 'md_nl_popup_dismissed_at_v1';
  const subscribedKey = 'md_nl_popup_subscribed_v1';
  const repeatAfter = 14 * 24 * 60 * 60 * 1000;
  let previousFocus = null;

  const getStore = (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const setStore = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // Storage can be unavailable in privacy-focused browsers.
    }
  };

  const visible = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none'
      && style.visibility !== 'hidden'
      && Number(style.opacity || 1) > 0
      && rect.width > 0
      && rect.height > 0;
  };

  const klaviyoVisible = () => {
    const selectors = ['.klaviyo-form', '[data-testid="signup-form"]', '[data-testid="form-component"]'];
    return Array.from(document.querySelectorAll(selectors.join(','))).some((element) => {
      if (!visible(element)) return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 280 && rect.height > 160;
    });
  };

  const focusables = () => Array.from(
    dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
  ).filter(visible);

  const close = (remember = true) => {
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('md-nl-popup-open');

    if (remember && !preview) setStore(dismissedKey, String(Date.now()));
    if (previousFocus instanceof HTMLElement) previousFocus.focus();
  };

  const open = () => {
    if (!preview && klaviyoVisible()) return;

    previousFocus = document.activeElement;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('md-nl-popup-open');

    window.requestAnimationFrame(() => {
      (success || popup.querySelector('input[type="email"]') || dialog).focus();
    });
  };

  closeButtons.forEach((button) => button.addEventListener('click', () => close(true)));

  popup.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      close(true);
      return;
    }

    if (event.key !== 'Tab') return;

    const items = focusables();
    if (!items.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }

    const first = items[0];
    const last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  new MutationObserver(() => {
    if (!preview && !popup.hidden && klaviyoVisible()) close(false);
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true });

  if (success) {
    setStore(subscribedKey, 'true');
    window.setTimeout(open, preview ? 100 : 200);
    return;
  }

  if (preview) {
    window.setTimeout(open, 100);
    return;
  }

  if (window.Shopify && window.Shopify.designMode) return;
  if (getStore(subscribedKey) === 'true') return;

  const dismissedAt = Number(getStore(dismissedKey) || 0);
  if (dismissedAt && Date.now() - dismissedAt < repeatAfter) return;

  const schedule = () => window.setTimeout(open, 4500);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();
